import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const OrderCenter: RouteConfig = {
  path: '/order-center',
  component: Layout,
  redirect: 'noredirect',
  name: 'OrderCenter',
  meta: {
    title: 'ordercenter',
    permission: 'OrderCenter',
    icon: 'guide'
  },
  children: [{
    path: 'order-manage/index',
    component: () => import(/* webpackChunkName: "orderManagement" */ '@/views/ordercenter/ordermanage/index.vue'),
    name: 'orderManagement',
    meta: {
      title: 'ordermanage',
      permission: 'orderManagement',
      noCache: true,
      icon: 'order-manage'
    }
  },
  {
    path: 'proxy-settlement/index',
    component: () => import(/* webpackChunkName: "agentSettlement" */ '@/views/ordercenter/proxysettlement/index.vue'),
    name: 'agentSettlement',
    meta: {
      title: 'proxysettlement',
      permission: 'agentSettlement',
      noCache: true,
      icon: 'order-settle'
    }
  },
  {
    path: 'entrance-manage/index',
    component: () => import(/* webpackChunkName: "applicant" */ '@/views/ordercenter/entrancemanage/index.vue'),
    name: 'applicant',
    meta: {
      title: 'applicant',
      permission: 'applicant',
      noCache: true,
      icon: 'base-bschool'
    }
  },
  {
    path: 'order-detail/index',
    component: () => import(/* webpackChunkName: "orderdetail" */ '@/views/ordercenter/ordermanage/detail/index.vue'),
    name: 'orderdetail',
    meta: {
      title: 'orderdetail',
      noCache: true,
      activeMenu: '/order-center/order-manage/index',
      hidden: true,
      icon: 'guide'
    }
  },
  {
    path: 'settle-detail/index',
    component: () => import(/* webpackChunkName: "settledetail" */ '@/views/ordercenter/proxysettlement/detail/index.vue'),
    name: 'settledetail',
    meta: {
      title: 'settledetail',
      noCache: true,
      activeMenu: '/order-center/proxy-settlement/index',
      hidden: true,
      icon: 'guide'
    }
  }]
}

export default OrderCenter
